import styled, { css } from 'styled-components'
import { breakpoints } from 'helpers/utils'

const { mobile } = breakpoints

export const StyledWeatherAndDate = styled.div`
	min-height: 94px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	& .dateCalendarWrapper{
		margin-right: 0;
		flex-direction: row;
	}

	& .header_item_date{
		margin-left: 41px;
	}

	@media (max-width: 1200px){
		& .calendarShown{
			left: 0;
		}
	}
	@media (max-width: 768px){
		min-height: 106px;
		& .col{
			flex-basis: 50%;
			max-width: 50%;
		}
		& .header_item_date{
			margin-left: 39px;
		}
		& .header_item_date{
			font-size: 13px;
			&  span:first-child .formated_date{
				font-size: 1em;
			}
			& .calendar_icon svg, .calendar_icon_first svg{
				width: 2.5em;
				height: 2.5em;
			}
			& .branch_dateCalendar{
				font-size: 1em;
				float: none;
				height: 2.5em;
				margin-left: 0;
			}
		}
		& .calendarShown{
			left: 50%;
		}
	}
	@media (max-width: 575px){
		& .header_item_date{
			font-size: 12px;
		}
	}
	@media (max-width: 535px){
		& .header_item_date{
			font-size: 11px;
		}
	}
	@media (max-width: 512px){
		min-height: 94px;
		& .header_item_date{
			font-size: 10px;
		}
	}
	@media (max-width: 464px){
		& .header_item_date{
			font-size: 1.93965517vw;
		}
	}
	@media (max-width: 416px){
		min-height: 84px;
		& .header_item_date{
			font-size: 8px;
			margin-left: 34px;
			& .branch_dateCalendar{
				border-radius: 3px;
			}
		}
	}
	@media (max-width: 378px){
		min-height: 74px;
		& .header_item_date{
			font-size: 7px;
		}
	}
	@media (max-width: 344px){
		& .header_item_date{
			font-size: 6px;
			& .branch_dateCalendar{
				border-radius: 2px;
			}
		}
	}
`

export const StyledBranchHeaderAndWeather = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	@media (max-width: 378px){
		margin-bottom: 0px;
	}
	.backBtn{
		margin-right: 0;
		&:hover{
			& svg path{
				stroke: #434343;
			}
		}
	}
	// BRANCH NAME
	h3{
		font-size: 36px;
		font-weight: 600;
		color: #434343;
		@media (max-width: 1200px){
			font-size: 28px;
		}
		@media (max-width: 768px){
			font-size: 23px;
		}
		@media (max-width: 416px){
			font-size: 22px;
			margin-left: -4px;
		}
		@media (max-width: 330px){
			font-size: 18px;
		}
	}
	.weather-info{
		margin-left: 20px;
		position: relative;
		& i{
			font-size: 33px !important;
			color: #B0B0B0;
		}
		& p{
			font-size: 12px;
			font-weight: 700;
			color: #B0B0B0;
			position: absolute;
			top: -10px;
			right: -25px;
			& span{
				margin-left: 1px;
			}
		}
		@media (max-width: 1200px){
			margin-left: 15px;
			& i{
				font-size: 26px !important;
			}
			& p{
				font-size: 11px;
				font-weight: 700;
			}
		}
		@media(max-width: 768px){
			${({ isTitleBig }) => isTitleBig && css`
				left: -15px;
			`}
		}
		@media(max-width: 585px){
			margin-right: 21px;
		}
		@media (max-width: 416px){
			margin-left: 10px;
			& i{
				font-size: 20px !important;
			}
			& p{
				font-size: 9px;
				font-weight: 700;
				right: -22px;
			}
		}
		@media (max-width: 330px){
			& i{
				font-size: 16px !important;
			}
			& p{
				right: -20px;
			}
		}
	}
`

export const StyledHeaderBack = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: 45px;
	& .back_btn {
			display: flex;
			align-items: center;
			&:hover {
					cursor: pointer;
			}
			& .arrow {
					border: solid #3e4c57;
					border-width: 0 1px 1px 0;
					display: inline-block;
					padding: 3px;
					&.left {
							transform: rotate(135deg);
					-webkit-transform: rotate(135deg);
					}
			}
			& span {
					font-size: 16px;
					font-weight: 300;
					font-stretch: normal;
					font-style: normal;
					line-height: normal;
					letter-spacing: normal;
					color: #3e4c57;
					margin-left: 10px;
			}
			@media (${mobile}) {
					justify-content: center;
			}
	}
	& .title {
		font-size: 30px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
			letter-spacing: normal;
			color: #3e4c57;
			margin-top: 5px;
			@media (${mobile}) {
					font-size: 24px;
			}
	}
	@media (${mobile}) {
			flex-direction: column-reverse;
			margin-right: 0;
	}
`
